export default {
    methods: {
        getImage: function (filename) {
            return '/chatbot/images/' + filename + '?v=dasd67dsdj';
        },
    },
};
